import { Slide } from "@jelly/lesson";

import { task as task01 } from "../../../../../task/course-03/lesson-05/task-01";

const task: Slide = {
  title: "Link the elements of the left column to the ones of the right column.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task01.id,
        },
      },
    },
  },
};

export default task;
